const authProvider = window.REACT_APP_AUTH_PROVIDER;
let baseURL = authProvider === 'OKTA'
  ? (window.OKTA_API_ENDPOINT || window.API_ENDPOINT)
  : window.API_ENDPOINT;
// let saBffBaseUrl = window.SA_AI_API_ENDPOINT || window.API_ENDPOINT;
// let miAiBaseUrl = "http://localhost:8080";
let miAiBaseUrl = window.MI_AI_API_ENDPOINT || window.SA_AI_API_ENDPOINT;
//let miAiBaseUrl = window.SA_AI_API_ENDPOINT || window.MI_AI_API_ENDPOINT;
let saBffBaseUrl =
  window.SA_AI_API_ENDPOINT ||
  "https://apim-na-ai.dev.mypepsico.com/cgf/spendanalytics-ai-api/v1";
export const appConstants = {
  URL: "http://localhost:3000",
  // BASE_URL: 'http://localhost:8000',
  // BASE_URL: 'https://apim-na.dev.mypepsico.com/cgf/buyers-console-api/v1',
  BASE_URL: baseURL,
 // SA_AI_BASE_URL:
 //   "https://spendanalytics-ai-api.dps.gw01.aks01.eus.nonprod.azure.intra.pepsico.com",
  MI_AI_BASE_URL: miAiBaseUrl,
  SA_AI_BASE_URL: saBffBaseUrl,
  inUSDMillion: "(in USD Million)",
};
